<div #carouselItem class="ui-carousel-item fade" [ngStyle]="transition" appSwiper tabindex="-1" style="outline: none">
    <app-content-viewer [content]="slideHTML" ></app-content-viewer>
</div>
